import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入语言资源
import zhCN from './locale/zh.json';
import enUS from './locale/en.json';

const browserLng = navigator.language.toLowerCase();
const defaultLng = browserLng.includes('en') ? 'en-US': 'zh-CN';
const setLng = localStorage.getItem('language') || defaultLng;
// 初始化i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': {
        translation: zhCN,
      },
      'en-US': {
        translation: enUS,
      },
    },
    lng: setLng,
    fallbackLng: 'zh-CN',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React已经做了XSS防护
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: [],
      lookupLocalStorage: 'language',
    },
  });

export default i18n;